import classNames from 'classnames';

import ContentBox from '@components/atoms/ContentBox';
import Typography from '@components/atoms/Typography';

import classes from './DialogsBoxes.module.scss';

export type Props = {
  className?: string;
  firstSection: {
    title: string;
    description?: string;
    list: {
      title: string;
      items: Array<{
        id: number;
        text: string;
      }>;
    };
  };
  secondSection: {
    title: string;
    description: string;
  };
};

const DialogsBoxes = ({ className, firstSection, secondSection }: Props): JSX.Element => (
  <div className={classNames(className, classes.wrapper)}>
    <ContentBox>
      <Typography variant="h1" renderAs="p" className={classes.title}>
        {firstSection.title}
      </Typography>
      {firstSection.description && (
        <Typography variant="h2" renderAs="p" className={classes.firstSubtitleWrapper}>
          {firstSection.description}
        </Typography>
      )}
      <Typography variant="h2" renderAs="p" weight="700" className={classes.listTitle}>
        {firstSection.list.title}
      </Typography>
      <Typography variant="h2" renderAs="span">
        <ul className={classes.list}>
          {firstSection.list.items.map(({ text, id }) => (
            <li key={id}>{text}</li>
          ))}
        </ul>
      </Typography>
    </ContentBox>
    <ContentBox variant="border" className={classes.secondWrapper}>
      <Typography variant="h1" renderAs="p" className={classNames(classes.title, classes.secondTitle)}>
        {secondSection.title}
      </Typography>
      <Typography variant="h2" renderAs="p">
        {secondSection.description}
      </Typography>
    </ContentBox>
  </div>
);

export default DialogsBoxes;
